import { QueryConfig } from "store/utils/query-config";

export const holidayQuotesDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"]
  }
};
